<div
  [class.analytic-func]="isAnalyticCalc"
  [class.discrete]="isDiscrete"
  [class.continuous]="isContinuous"
  [class.invalid]="!isValid"
  [class.dual-axis]="isDualAxis && !isSharedAxis && !hideDualAxisAffordances"
  [class.dual-axis-relative]="isDualAxisRelative && !hideDualAxisAffordances"
  [class.multiple]="isMultiple"
  [title]="title"
  capraTooltip
  [tooltipContent]="tooltipContent"
  [tooltipIsDisabled]="!tooltipContent"
  [tooltipInteractive]="tooltipInteractive"
  [tooltipDelay]="tooltipDelay"
  tooltipPlacement="bottom"
>
  <span class="text">{{ displayName }}</span>
  <capra-icon
    *ngIf="errorMessage"
    capraTooltip
    [tooltipContent]="errorMessage"
    tooltipPlacement="bottom"
    [tooltipInteractive]="tooltipInteractive"
    [tooltipDelay]="tooltipDelay"
    tooltipSize="regular-thin"
    icon="icon-warning"
    class="warning-state"
  ></capra-icon>
  <capra-icon *ngIf="secondaryIcon" icon="{{ secondaryIcon }}" [className]="secondaryIconClass"></capra-icon>
  <span class="icon-list">
    <capra-icon *ngIf="isAnalyticCalc" icon="icon-table-cal"></capra-icon>
    <span class="context-menu-target" (click)="onContextMenu($event)">
      <capra-icon icon="icon-caret-down" [className]="caretIcon"></capra-icon>
    </span>
  </span>
</div>
